import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./FeaturedCoursesCarousel.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const FeaturedCoursesCarousel = () => {
  const navigate = useNavigate();

  const cards = [
    {
      id: "engineering-survey",
      image: "/images/courses/engineering-survey.webp",
      description: "Engineering Survey",
      breif: "Learn advanced surveying techniques using modern tools for accurate field...",
    },
    {
      id: "non-destructive-test",
      image: "/images/courses/NDT.jfif",
      description: "Non Destructive Test",
      breif: "Understand NDT methods to evaluate material strength without causing any...",
    },
    {
      id: "quantity-estimation-and-costing",
      image: "/images/courses/estimate.webp",
      description: "Quantity Estimation and Costing",
      breif: "Master project estimation techniques and costing to ensure budget accuracy...",
    },
    {
      id: "project-drafting-with-autocad",
      image: "/images/courses/autocad.jpg",
      description: "Project Drafting with Auto-CAD",
      breif: "Learn professional drafting using AutoCAD to create precise civil...",
    },
    {
      id: "concept-of-site-engineering",
      image: "/images/courses/site engineering.avif",
      description: "Concept of Site Engineering",
      breif: "Gain hands-on knowledge of site management, planning, and execution...",
    },
    {
      id: "sub-soil-exploration-and-testing",
      image: "/images/courses/soil-exploration.webp",
      description: "Sub-soil Exploration & Testing",
      breif: "Explore soil investigation techniques to assess foundation conditions and...",
    },
    {
      id: "quality-control-and-material-testing",
      image: "/images/courses/quality-control.png",
      description: "Quality Control & Material Testing",
      breif: "Learn testing procedures for construction materials to ensure compliance...",
    },
    {
      id: "latest-technology-of-geo-tagging",
      image: "/images/courses/geo-tagging.jpg",
      description: "Latest Technology of Geo-Tagging",
      breif: "Understand modern geo-tagging methods for precise location mapping in civil...",
    },
  ];

  // State to dynamically track the number of cards
  const [cardsToShow, setCardsToShow] = useState(3);

  const updateCardsToShow = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1200) {
      setCardsToShow(3); // Desktop
    } else if (screenWidth >= 800) {
      setCardsToShow(2); // Tablet
    } else {
      setCardsToShow(1); // Mobile
    }
  };

  useEffect(() => {
    updateCardsToShow(); // Set the initial count
    window.addEventListener("resize", updateCardsToShow); // Update on resize
    return () => window.removeEventListener("resize", updateCardsToShow); // Cleanup
  }, []);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: cardsToShow, // Dynamically control the number of items
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: cardsToShow,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: cardsToShow,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: cardsToShow,
    },
  };

  const handleKnowMore = (id) => {
    navigate(`/training#${id}`); // Navigate to the course section
  };

  return (
    <div className="featured-courses-carousel">
      <h2 className="text-center heading">Featured Courses</h2>
      <div className="carousel-wrapper">
        <Carousel
          swipeable={true}
          draggable={true}
          showDots={false}
          responsive={responsive}
          ssr={true}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={5000}
          keyBoardControl={true}
          customTransition="transform 0.5s ease"
          transitionDuration={500}
          containerClass="carousel-container"
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {cards.map((card, index) => (
            <div key={index} className="fc-card">
              <div className="fc-image-container">
                <img src={card.image} alt={card.description} />
              </div>
              <div className="card-body">
                <h5>{card.description}</h5>
                <p>{card.breif}</p>
                <button
                  className="btn btn-primary"
                  onClick={() => handleKnowMore(card.id)}
                >
                  Know More <i class="fa-solid fa-circle-info mw-2"></i>
                </button>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default FeaturedCoursesCarousel;
